export default __webpack_public_path__ + "static/media/ui-icon-balance-chip.e7c3d3ba.svg";